import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Typography } from '@mui/material';
import SolutionManagementTableColum from './solutionManagementColumn';
import { useNavigate } from 'react-router-dom';
import { getAllInitiative } from './initiative.service';
import './initiative.css';
import Loader from '../../../components/loader';
import GenericDataGrid from '../../../components/genericTable';

export default function SolutionManagementTable() {

    const navigate = useNavigate();
    const [initiativeData, setInitiativeData] = useState([
        {
            id: 1,
            solutionName: "ALLIN FIX",
            ecosystem: "-",
            description: "-",
            profile: "-"
        },
        {
            id: 2,
            solutionName: "ALLIN FIT",
            ecosystem: "-",
            description: "-",
            profile: "-"
        },
        {
            id: 3,
            solutionName: "ALLIN FLEX",
            ecosystem: "-",
            description: "-",
            profile: "-"
        },
        {
            id: 4,
            solutionName: "ALLIN IMPACT",
            ecosystem: "-",
            description: "-",
            profile: "-"
        },
        {
            id: 5,
            solutionName: "ALLIN TRUST",
            ecosystem: "-",
            description: "-",
            profile: "-"
        }
    ]);

    const [errors, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [currenntPagemain, setCurrentPagemain] = useState(0);
    const [rowsperpagemain, setrowsperpagemain] = useState(5);
    const paginatedData = initiativeData.slice(
        currenntPagemain * rowsperpagemain,
        currenntPagemain * rowsperpagemain + rowsperpagemain
    );

    useEffect(() => {
        getInitiativeData(currenntPagemain, rowsperpagemain);
    }, []);

    const getInitiativeData = async (page = currenntPagemain, limit = rowsperpagemain) => {
        setLoading(true);
        const res = await getAllInitiative(page, limit);
        setLoading(false);

        // if (res.statusCode === 200) {
        //   setInitiativeData(res.data.initiativeList);
        //   setTotalDataCount(res.data.pagination.totalItems);
        // } else if (res.statusCode === 400 || res.statusCode === 401 || res.statusCode === 404 || res.statusCode === 500) {
        //   setInitiativeData([]);
        //   setError(res.message);
        // }
        // else {
        //   setInitiativeData([]);
        //   setError(res.message);
        // }
    };

    let solutionData = {
        'limit': '',
        'page': '',
        'navigate': navigate,
        'getInitiativeData': getInitiativeData
    }
    const solutionManagementColumn = SolutionManagementTableColum(solutionData);

    return (
        <>

            <Grid container mb={2} alignItems={'center'} >
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography sx={{ fontSize: '28px', fontWeight: 600 }}>Solution Management</Typography>
                </Grid>
            </Grid>

            <Box sx={{ width: '100%', padding: '0 0px' }}>
                <GenericDataGrid
                    rows={paginatedData}
                    columns={solutionManagementColumn}
                    rowCount={initiativeData.length}
                    page={currenntPagemain}
                    pageSize={rowsperpagemain}
                    loading={false}
                    errors={errors}
                    checkbox='false'
                    onPaginationChange={(page, pageSize) => {
                        setCurrentPagemain(page);
                        setrowsperpagemain(pageSize);
                    }}
                />
            </Box>
            {loading && <Loader />}

        </>
    );
}